module.exports = __webpack_public_path__ + "tiktok-shadow.028f74b6ca8bd875592a4428ebb25649.svg";